:host {
  --_arc-color: var(--spinner-arc-color-brand);
  --_size: var(--spinner-size-md);
  --_stroke-width: var(--spinner-stroke-width-md);

  display: inline-block;
  position: relative;
  flex-shrink: 0;
  inline-size: var(--_size);
  block-size: var(--_size);
}

:host([size='xs']) {
  --_size: var(--spinner-size-xs);
  --_stroke-width: var(--spinner-stroke-width-xs);
}

:host([size='sm']) {
  --_size: var(--spinner-size-sm);
  --_stroke-width: var(--spinner-stroke-width-sm);
}

:host([size='md']) {
  --_size: var(--spinner-size-md);
  --_stroke-width: var(--spinner-stroke-width-md);
}

:host([size='lg']) {
  --_size: var(--spinner-size-lg);
  --_stroke-width: var(--spinner-stroke-width-lg);
}

:host([variant='brand']) {
  --_arc-color: var(--spinner-arc-color-brand);
}

:host([variant='dark']) {
  --_arc-color: var(--spinner-arc-color-dark);
}

:host([variant='light']) {
  --_arc-color: var(--spinner-arc-color-light);
}

:host([variant='light-on-color']) {
  --_arc-color: var(--spinner-arc-color-light-on-color);
}

.arc {
  position: absolute;
  inset: 0;
  display: inline-block;
  border-radius: 50%;
  border-style: solid;
  border-width: var(--_stroke-width);
  border-color: var(--_arc-color);
  border-top-color: transparent;
  box-sizing: border-box;
  rotate: 45deg;
  animation: spinner-rotate var(--spinner-transition-duration) var(--spinner-transition-timing-function) infinite;
}

@keyframes spinner-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .arc {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}
